import moment from 'moment';

export const validateDateBetween = (context: DynamicForm.Context, field: DynamicForm.Data, params: any) => {
	return (value: string): boolean => {
		return moment(value).isBetween(params.from, params.to, null, '[]');
	};
};
